// extracted by mini-css-extract-plugin
export var ands = "Partner-module--ands--gDcoQ";
export var container = "Partner-module--container--b3M+q";
export var lineLink = "Partner-module--line-link--GK3cc";
export var lineLink_black = "Partner-module--line-link_black--aY6hs";
export var lineLink_grey = "Partner-module--line-link_grey--4S5SK";
export var lineLink_primary = "Partner-module--line-link_primary--JjR2A";
export var lineLink_secondary = "Partner-module--line-link_secondary--LFerK";
export var lineLink_white = "Partner-module--line-link_white--b6MQt";
export var logos = "Partner-module--logos--DUM6u";